<div class="unauthorized-container flex-column">
  <span class="material-symbols-outlined no-access"> block </span>
  <span class="no-access-text">{{ "unauthorized" | translate }}</span>
</div>
